<!DOCTYPE html>
<html lang="en">
<head>
	<meta charset="UTF-8">
	<title>Home and Profiles</title>
	<link rel="stylesheet" href="./home.component.css">
</head>
<div class = "row" style="margin-top: 2%; background-color: rgba(0, 0, 0, 0.357)">
  <div class = "col" style="width: 80%;">
    <h1 style=" font-family:Alegreya; margin-top: 5%; text-align: center; font-size: 160px; color: white;">Formularios dinámicos</h1>
  </div>
  <div class = "col" style="width: 20%;vertical-align: middle">
    <p style="font-family:Alegreya; margin-top: 35%; text-align: right; font-size: 24px; color: white;">En el menu de arriba encontrará opciones para disfrutar las funcionalidades de la pagina y abajo podrá ver detalles de los creadores.</p>
  </div>
</div>
  <div class = "row" style="text-align: center; padding:10% 0% 10% 0% ; margin-top: 20%; margin-bottom: 3%; background-color: rgba(0, 0, 0, 0.357); "> 
  <div class = "col" style="margin:5%;">
    <div class="image-area" >
      <div class="img-wrapper">
        <img src="https://i.imgur.com/AMu5Xjs.jpg" alt="Madrigal">
        <h2>Esteban Madrigal</h2>
        <ul>
          <li><a href="https://github.com/madri308" target="_blank"><i class="fab fa-github"></i></a></li>
          <li><a href="https://www.instagram.com/madri.g/" target="_blank"><i class="fab fa-instagram"></i></a></li>
          <li><a href="https://twitter.com/Madri30" target="_blank"><i class="fab fa-twitter"></i></a></li>
          <li><a href="https://www.youtube.com/channel/UCmCWEdc5yg7lBczDqtgqdKA?view_as=subscriber" target="_blank"><i class="fab fa-youtube"></i></a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class = "col" style="margin:5%;">
    <div class="image-area" >
      <div class="img-wrapper">
        <img src="https://i.imgur.com/qm9SQM2.jpg" alt="Fallas">
        <h2>Kevin Fallas</h2>
        <ul>
          <li><a href="https://github.com/KevinFallas03" target="_blank"><i class="fab fa-github"></i></a></li>
          <li><a href="https://www.instagram.com/" target="_blank"><i class="fab fa-instagram"></i></a></li>
          <li><a href="https://twitter.com/" target="_blank"><i class="fab fa-twitter"></i></a></li>
          <li><a href="https://www.youtube.com/" target="_blank"><i class="fab fa-youtube"></i></a></li>
        </ul>
      </div>
    </div>
  </div>
    <div class = "col" style="margin:5%;">
      <div class="image-area" >
        <div class="img-wrapper">
          <img src="https://i.imgur.com/qWH4IhH.jpg" alt="Vega">
          <h2>Josue Rojas</h2>
          <ul>
            <li><a href="https://github.com/JOSUERV99" target="_blank"><i class="fab fa-github"></i></a></li>
            <li><a href="https://www.instagram.com/" target="_blank"><i class="fab fa-instagram"></i></a></li>
            <li><a href="https://twitter.com/" target="_blank"><i class="fab fa-twitter"></i></a></li>
            <li><a href="https://www.youtube.com/" target="_blank"><i class="fab fa-youtube"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class = "col" style="margin:5%;">
      <div class="image-area" >
        <div class="img-wrapper">
          <img src="https://i.imgur.com/5cZC1vr.jpg" alt="Castro">
          <h2>David Castro</h2>
          <ul>
            <li><a href="https://github.com/dcastro18" target="_blank"><i class="fab fa-github"></i></a></li>
            <li><a href="https://www.instagram.com/" target="_blank"><i class="fab fa-instagram"></i></a></li>
            <li><a href="https://twitter.com/" target="_blank"><i class="fab fa-twitter"></i></a></li>
            <li><a href="https://www.youtube.com/channel/" target="_blank"><i class="fab fa-youtube"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class = "col" style="margin:5%;">
      <div class="image-area" >
        <div class="img-wrapper">
          <img src="https://i.imgur.com/IFRSXfJ.jpg" alt="Sanchez">
          <h2>Kenneth Sanchez</h2>
          <ul>
            <li><a href="https://github.com/KennethS0" target="_blank"><i class="fab fa-github"></i></a></li>
            <li><a href="https://www.instagram.com/atulkprajapati2000/" target="_blank"><i class="fab fa-instagram"></i></a></li>
            <li><a href="https://twitter.com/atuljustano" target="_blank"><i class="fab fa-twitter"></i></a></li>
            <li><a href="https://www.youtube.com/channel/UCf-KfxuY8PZBSD_8RW2nYsw" target="_blank"><i class="fab fa-youtube"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <footer style="text-align: center; color: rgba(255, 255, 255, 0.5);">
      <p>Formularios Mongo • bases de datos II • 2020
      <br><a href="https://www.tec.ac.cr/" target="_blank">Tecnológico de Costa Rica</a>
      <br><a href="https://github.com/KevinFallas03/DynamicFormBuilder-BD2-2S-2020.git" target="_blank">Codigo en GitHub</a>
    </p>
  </footer>
</html>